<template>
  <section id="home-intro">
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <h1><span style="display:none">Oldtimers Garage</span></h1>
        </div>
      </div>
    </div>
  </section>

</template>

<script>
export default {
}
</script>

<style>
#home-intro {
  background: url('../../assets/img/bg/bg_praga_alfa.jpg') top center fixed no-repeat;
  background-size: cover;
  height: 100%;
  margin: 0 auto;
  width: 100%;
  position: relative;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// IntroLarge.vue?8ec4836c